import {bool} from 'prop-types';
import {useNavigate} from 'react-router-dom';

import usePayment from '../../hooks/providers/usePayment';
import useProjects from '../../hooks/providers/useProjects';
import useReport from '../../hooks/providers/useReport';
import Button from '../form/buttons/Button/Button';

const SeeCustomReportButton = ({isCustomReport}) => {
  const navigate = useNavigate();
  const {currentReport, selectedReportTab} = useProjects();
  const {embedToken, reports} = useReport();
  const {isAdmin, isAdminOff} = usePayment();

  const report = reports.find(r => r.report_id === selectedReportTab);
  const reportIsNotInEmbedTokenBecauseAdminUser = !reports.find(r => r.report_id === report?.report_id) && (isAdmin || isAdminOff);
  const isDisabled = !embedToken || (!report && isCustomReport) || reportIsNotInEmbedTokenBecauseAdminUser;

  const hasTooltip = isDisabled;

  const getTooltipMessage = () => {
    if (!embedToken) {
      return 'Rapport bientôt disponible.';
    }

    if (!report && isCustomReport) {
      return "Aucun Rôle fourni à l'import de ce rapport. Veuillez supprimer et réimporter le rapport en nommant le Rôle associé aux rapport.";
    }

    if (reportIsNotInEmbedTokenBecauseAdminUser) {
      return "Ajoutez-vous en tant qu'utilisateur pour accéder au rapport.";
    }

    return '';
  };

  const tooltipText = getTooltipMessage();
  const urlToReport = `/reports/${currentReport.report_name}`;

  return (
    <Button
      hasTooltip={hasTooltip}
      tooltip={tooltipText}
      onClick={() => navigate(urlToReport, {state: {reportId: currentReport.report_id}})}
      sx={{margin: '0 auto', display: 'block'}}
      size="large"
      disabled={isDisabled}
      variant="contained"
      color="secondary"
    >
      Consulter le rapport
    </Button>
  );
};

SeeCustomReportButton.propTypes = {
  isCustomReport: bool.isRequired
};

export default SeeCustomReportButton;
